











































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { VbLoadingService, VbSnackbarService } from 'bag-of-holding-library';
import { hasEmployeeAdministratorAuthority, hasManagerAuthority } from '@/shared/directive/has-authority.directive';
import TabButton from '@/shared/tab-button.component.vue';
import CardTitle from '@/shared/card/card-title.component.vue';
import EmployeeService from '@/domain/employees/service/employee.service';
import Employee from '@/domain/employees/entity/employee.entity';
import CareerUpdate from '@/domain/employees/entity/career-update.entity';
import CareerService from '@/domain/employees/service/career.service';
import InternalMovementService from '@/domain/internal-movement/service/internal-movement.service';
import ModalOptions from '@/shared/modal/modal-options.entity';
import InternalMovementRequest from '@/domain/internal-movement/entity/internal-movement-request.entity';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import InternalMovementModal from '@/views/internal-movement/internal-movement-modal.component.vue';
import ProfileMenu from '../../profile-menu.component.vue';
import UpdateList from './career-update-list.component.vue';
import CreateModal from '../../modal/create-update-modal.component.vue';
import HistoryModal from '../../modal/history-modal.component.vue';

@Component({
  components: {
    TabButton,
    UpdateList,
    ProfileMenu,
    CreateModal,
    HistoryModal,
    CardTitle,
    ModalWarning,
    InternalMovementModal,
  },
  directives: { hasEmployeeAdministratorAuthority, hasManagerAuthority },
})
export default class CarrerDataComponent extends Vue {
  @Prop() unlockUpdateCareerUpdate!: boolean;

  @Prop() checkAccessCreateCareerUpdate!: boolean;

  @Prop() unlockDeleteCareerUpdate!: boolean;

  @Prop() unlockDeletePastCareerUpdate!: boolean;

  @Prop() checkAccessReadUpdateHistory!: boolean;

  @Prop() checkAccessCreateInternalMovement!: boolean;

  @Prop({
    type: Boolean,
  }) hasUpdatePastCareerUpdateEvent!: boolean;

  @Prop({
    type: [Employee || Object],
    default: () => new Employee({}),
  }) employee!: Employee;

  @Prop({
    type: Boolean,
    default: false,
  }) isAdministrator!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) isBusinessPartner!: boolean;

  updates: CareerUpdate[] = [];

  aux: CareerUpdate = new CareerUpdate({});

  showCreate: boolean = false;

  showAlert: boolean = false;

  showInternalMovementModal: boolean = false;

  deletableUpdate: CareerUpdate = new CareerUpdate({});

  showHistory: boolean = false;

  authorities: any = '';

  reset: boolean = false;

  edit: boolean = false;

  key: string = '';

  current: CareerUpdate = new CareerUpdate({});

  loadingSaveButton: boolean = false;

  unlockDeleteCareerUpdateForLengthGreaterThanOne: boolean = false;

  totalCareerUpdates: number = 0;

  page: number = 0;

  loading: boolean = false;

  isCareerUpdatePast: boolean = false;

  get modalWarningOptions(): ModalOptions {
    return {
      title: 'Atenção!',
      description: 'Deseja realmente prosseguir? Ao clicar no botão Sim, o evento será imediatamente descartado.',
      showOk: true,
      disabledOk: false,
      labelOk: 'Sim',
      okColor: 'tabBlue',
      showCancel: true,
      labelCancel: 'Não',
      width: 400,
    };
  }

  back() {
    this.$router.push('/');
  }

  get hasContent() {
    return this.updates.length === 0;
  }

  @Watch('employee')
  getProfile() {
    if (this.employee) {
      this.getUpdates();
    }
  }

  async getUpdates() {
    this.loading = true;
    await CareerService.getAllCareerUpdates(this.employee.id, this.page)
      .then((response: any) => {
        this.updates.push(...response.content.map(item => new CareerUpdate(item)));
        this.unlockDeleteCareerUpdateForLengthGreaterThanOne = this.unlockDeleteCareerUpdate
          && this.updates.length > 1;
        this.finallyCareerFetch();
        this.totalCareerUpdates = response.totalElements;
        this.page += 1;
      }).catch((error) => {
        VbSnackbarService.handleHttpError(error)
      }).finally(() => {
        this.loading = false;
      });
  }

  setSelected(): void {
    this.updates.forEach((el: CareerUpdate) => {
      el.unselect();
      this.$forceUpdate();
    });
  }

  async saveNewUpdate(update: CareerUpdate) {
    VbLoadingService.show();
    this.loadingSaveButton = true;
    try {
      await CareerService.saveCareer(this.employee.id, update.setUpdateValues())
      VbSnackbarService.showSuccess('Evento salvo com sucesso');
      this.updates = [];
      this.page = 0;
      await this.getUpdates();
      this.showCreate = false;
      this.updates[0].select();
      this.updateKey();
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      VbLoadingService.hide();
      this.loadingSaveButton = false;
    }
  }

  saveNewInternalMovement(movement: InternalMovementRequest) {
    VbLoadingService.show();
    this.loadingSaveButton = true;
    movement.employeeId = this.employee.id;
    InternalMovementService.requestNewInternalMovement(movement.employeeId, movement.targetDate,
      movement.areasOfInterest, movement.bankHoursBalance)
      .then(() => {
        VbSnackbarService.showSuccess('Movimentação interna solicitada com sucesso');
        this.showInternalMovementModal = false;
      })
      .catch(err => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        VbLoadingService.hide();
        this.loadingSaveButton = false;
      });
  }

  updateKey() {
    this.key = new Date().toISOString();
  }

  requestMovementUpdateEvent() {
    this.showInternalMovementModal = true
  }

  createCareerUpdateEvent() {
    this.edit = false
    this.showCreate = true
    this.current = CareerUpdate.of(this.updates[0]);
  }

  editUpdate(value: CareerUpdate) {
    this.edit = true;
    this.current = value
    this.showCreate = true;
    this.isCareerUpdatePast = value.id !== this.updates[0].id;
  }

  deleteAlert(value: CareerUpdate) {
    this.showAlert = true;
    this.deletableUpdate = value;
  }

  deleteUpdate() {
    VbLoadingService.show();
    CareerService.deleteCareer(this.employee.id, this.deletableUpdate.id)
      .then(() => {
        VbSnackbarService.showSuccess('Evento excluido com sucesso');
        this.getUpdates();
        this.deletableUpdate = new CareerUpdate({});
      })
      .catch(err => VbSnackbarService.handleHttpError(err))
      .finally(() => VbLoadingService.hide());
  }

  updateCareer(career: CareerUpdate) {
    VbLoadingService.show();
    this.loadingSaveButton = true;
    CareerService.updateCareer(this.employee.id, career.id, career.setUpdateValues())
      .then((response: CareerUpdate) => {
        VbSnackbarService.showSuccess('Evento alterado com sucesso');
        const index = this.updates.findIndex((el: CareerUpdate) => el.id === response.id);
        this.updates = this.updates.map((el: CareerUpdate) => {
          if (el.id === response.id) {
            return response;
          }
          return el;
        });
        this.showCreate = false;
        this.updates[index].select();
        this.updateKey();
      })
      .catch(err => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        VbLoadingService.hide();
        this.loadingSaveButton = false;
      });
  }

  showModalHistory() {
    this.showHistory = true
  }

  finallyCareerFetch() {
    this.$emit('finallyCareerFetch', this.updates[0]);
  }
}
